import { useCallback } from 'react';
import { track } from './index';
import { useScreenName } from './useScreenName';
import type { TrackEvent, TrackEventType, TrackScreenName } from './types';

export function useTrack() {
  const routeScreenName = useScreenName();
  return useCallback(
    (
      event: TrackEventType,
      params: Omit<TrackEvent, 'event' | 'screenName'> & {
        screenName?: TrackScreenName;
      }
    ) => {
      const { screenName: _screenName, ...rest } = params;
      track({ ...rest, event, screenName: _screenName ?? routeScreenName });
    },
    [routeScreenName]
  );
}
